import React, { useState } from "react";
import Background from "assets/image/background.jpg";
import cn from "classnames";
import {
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Container,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import ValidationError from "components/validationError";
import { useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";
import { selectLanguage } from "store/selector/language";
import { Link ,useHistory } from "react-router-dom";
import {
  LOGIN_INITIAL_VALUE,
  LOGIN_VALIDATION_SHEMA,
} from "fixtureData/formikValidation";
import Auth from 'services/auth';

const Login = () => {
  const { t } = useTranslation();
  const [passwordShow, setPasswordShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const togglePasswordShow = () => {
    setPasswordShown(!passwordShow);
  };
  const history = useHistory();
  const formik = useFormik({
    initialValues: LOGIN_INITIAL_VALUE,
    validationSchema: LOGIN_VALIDATION_SHEMA,
    onSubmit: async (value) => {
      const {email, password} = value;
      const AuthClass = new Auth();
      setIsLoading(true);
      try {
        await AuthClass.login(email, password);
        setIsLoading(false);
        history.push("/");

      } catch(e) {
        setIsLoading(false);
      }
    },
  });

  const { errors, touched } = formik;

  return (
    <div className="p-5" style={{ backgroundImage: `url(${Background})` }}>
      <Container className="p-5">
        <Row>
          <Col className={"d-flex justify-content-center  p-4"}>
            <Card className={cn("overflow-hidden card--dark ")}>
              <Row>
                <Col
                  xs="12"
                  sm="12"
                  lg="5"
                  xl="5"
                  className={cn("p-5 text-light")}
                  style={{
                    backgroundImage: `url(${Background})`,
                  }}
                >
                  <h2 className="text-light">{t("Login")}</h2>
                  <h6 className="pt-4 pb-4">
                    {t("Enter your account information to enter the market")}
                  </h6>

                  <Trans i18nKey="You do not have an account">
                    <Button outline size="xs" color="danger">
                      {"Register"}
                    </Button>
                    <h6>{"do"}</h6>
                  </Trans>
                </Col>
                <Col xs="12" sm="12" lg="7" xl="7">
                  <CardImg alt="Logo" className="p-5" />

                  <CardBody>
                    <CardTitle tag="h6" className="pb-5">
                      {t("Register")} <hr />
                    </CardTitle>

                    <CardText>
                      <Form onSubmit={formik.handleSubmit}>
                        <FormGroup className={"form-group-style"}>
                          <Label for="email">
                            {t("Email")}
                            <sup>*</sup>
                          </Label>
                          <Input
                            id="email"
                            type="text"
                            {...formik.getFieldProps("email")}
                          />
                          <ValidationError
                            errors={errors}
                            touched={touched}
                            field="email"
                          >
                            {" "}
                            {errors.email}{" "}
                          </ValidationError>
                        </FormGroup>
                        <FormGroup className={cn("", "form-group-style")}>
                          <Label for="password">
                            {t("Password")}
                            <sup>*</sup>
                          </Label>

                          <InputGroup>
                            <Input
                              id="password"
                              {...formik.getFieldProps("password")}
                              type={passwordShow ? "text" : "password"}
                            />
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText onClick={togglePasswordShow}>
                                {passwordShow ? "show" : "hide"}
                              </InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                          <ValidationError
                            errors={errors}
                            touched={touched}
                            field="password"
                          >
                            {" "}
                            {errors.password}{" "}
                          </ValidationError>
                        </FormGroup>
                        <Link
                          className="ps-5"
                          to=""
                          style={{ textDecoration: "none" }}
                        >
                          {t("Forgot your password?")}
                        </Link>
                        <Button
                          type="submit"
                          outline
                          size="xs"
                          color="danger"
                          className="btn text-small"
                          disabled={isLoading}
                        >
                          {t("Confirm and send")}
                          {isLoading && ('...')}
                        </Button>
                        <hr />
                      </Form>
                    </CardText>
                    <Row>
                      <Col className="d-flex flex-column align-items-center justify-content-center">
                        <Button size="xs" color="secondary">
                          {t("Login with Google")}
                        </Button>
                        <p>
                          <Trans i18nKey="Signing in with Google means accepting coinnik Market">
                            <Link to="#">{"Terms and Conditions"}</Link>.
                          </Trans>
                        </p>
                      </Col>
                    </Row>
                  </CardBody>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
